import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'; // 1. Import the Provider
import store from './store/store';       // 2. Import your configured store
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* 3. Wrap your App component inside the Provider */}
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);